import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {Request, RequestsMixin, DELETE} from 'requests';

/* eslint-disable react/prop-types */
const MESSAGE_PROPS = {
  naming_issues: {
    alertType: 'danger',
    title: () => {
      return 'Naming Issues';
    },
    body: (message) => {
      const elements = Object.keys(message.payload).map((key) => {
        return (
          <li key={key}>
            <span className="text-danger font-weight-semibold">{key}</span>
            <i className="ficon ficon-long-arrow-right m-xs-x-xs"></i>
            {message.payload[key]}
          </li>
        );
      });

      return (
        <div>
          <p>
            Your site refers to the same icon in multiple ways. To keep them working, you need to <span className="text-danger font-weight-semibold">rename the following icons on your site</span>:
          </p>
          <ul className="p-xs-l-lg m-xs-b-sm">
            {elements}
          </ul>
        </div>
      );
    },
  },
  just_published: {
    alertType: 'success',
    title: () => {
      return 'First Publish!';
    },
    body: (message, props) => {
      return (
        <div>
          Nice work! Now you&apos;ll want to add your
          embed code to your site and check out your <Link to={`/kits/${props.kitToken}/docs`} className="text-success">documentation</Link>.
        </div>
      );
    },
  },
  publish_your_kit: {
    alertType: 'primary',
    title: () => {
      return 'Publish Your Kit!';
    },
    body: () => {
      return (
        <span>Once you&apos;ve added your icons and typefaces, remember to publish your kit. We&apos;ll generate and update all your files so they&apos;re ready to use!</span>
      );
    },
  },
  add_icons: {
    alertType: 'primary',
    title: () => {
      return 'Add Icons?';
    },
    body: (message, props) => {
      return (
        <div>
          Need some icons? You can <Link to={`/kits/${props.kitToken}/icons/new`}>add icons</Link> or <Link to={`/kits/${props.kitToken}/icons/upload`}>upload your own</Link>?
        </div>
      );
    },
  },
  add_typefaces: {
    alertType: 'primary',
    title: () => {
      return 'Add Typefaces?';
    },
    body: (message, props) => {
      return (
        <div>
          Your kit has no typefaces. Want to <Link to={`/kits/${props.kitToken}/typefaces/new`}>add typefaces</Link> or <Link to={`/kits/${props.kitToken}/typefaces/upload`}>upload your own</Link>?
        </div>
      );
    },
  },
};
/* eslint-enable react/prop-types */

const mapStateToProps = (state, ownProps) => {
  return {
    requests: state.requests,
  };
};

const KitMessages = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    requests: PropTypes.object.isRequired,
    kitToken: PropTypes.string.isRequired,
    messages: ImmutablePropTypes.list.isRequired,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  render() {
    let messageElements = [];
    const {
      messages,
    } = this.props;

    messageElements = messages.map((message) => {
      const messageProps = MESSAGE_PROPS[message.messageType];
      const deleteKitMessage = (event) => {
        event.preventDefault();

        this.setRequest({
          deleteKitMessage: new Request({
            method: DELETE,
            url: ['api', 'kits', this.props.kitToken, 'messages', message.id],
            record: message,
          }),
        });
      };

      return (
        <div key={message.id} className={`alert alert-${messageProps.alertType} bg-body text-sm m-xs-y-md`} role="alert">
          <button onClick={deleteKitMessage} type="button" className="close close-dangle-sm">
            <i className="ficon ficon-times"></i>
          </button>
          <h3 className="text-base">{messageProps.title(message, this.props)}</h3>
          <hr className="m-xs-y-sm"/>
          {messageProps.body(message, this.props)}
        </div>
      );
    });

    return (
      <div>
        {messageElements}
      </div>
    );
  },
});

export default connect(mapStateToProps)(KitMessages);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/KitMessages.js